"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracking = void 0;
/* eslint-disable @typescript-eslint/no-use-before-define */
var web_1 = require("@react-hookz/web");
var react_1 = require("react");
var events_1 = require("../events");
var hooks_1 = require("../hooks");
var lib_1 = require("../lib");
var const_1 = require("./const");
function Tracking() {
    var _a = (0, hooks_1.useAnalytics)(), alias = _a.alias, identify = _a.identify, track = _a.track, user = _a.user;
    var aliasRef = (0, web_1.useSyncedRef)(alias);
    var identifyRef = (0, web_1.useSyncedRef)(identify);
    var trackRef = (0, web_1.useSyncedRef)(track);
    var userRef = (0, web_1.useSyncedRef)(user);
    (0, react_1.useEffect)(function () {
        function handleClick(event) {
            if (event.target instanceof HTMLElement) {
                var nearestAnchor = event.target.closest('a');
                if (nearestAnchor) {
                    var url = new URL(nearestAnchor.href);
                    var isExternalDomain = url.hostname !== window.location.hostname;
                    var isUploadcareCdn = url.hostname === const_1.UPLOADCARE_CDN_HOSTNAME;
                    if (isExternalDomain && !isUploadcareCdn) {
                        track(events_1.ACTIONS.OUTBOUND_LINK_CLICK, { href: nearestAnchor.href });
                    }
                }
            }
        }
        document.addEventListener('click', handleClick);
        return function () { return document.removeEventListener('click', handleClick); };
    }, [track]);
    (0, react_1.useEffect)(function () {
        var utm = (0, lib_1.getUrlParameters)('utm_');
        var recipientId = utm.get('id');
        if (recipientId) {
            (0, lib_1.getRecipientInfo)(recipientId)
                .then(function (data) {
                identifyRef.current(data.id);
            })
                .catch(function (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            });
        }
    }, [aliasRef, identifyRef, userRef]);
    (0, react_1.useEffect)(function () {
        var hashParameters = window.location.hash.replace('#', '').split('-');
        var id = hashParameters.pop();
        var type = hashParameters.join('-');
        if (id && type) {
            // Auto-click assest passed in query parameters (used by campaign links)
            // Pulled from https://github.com/prezly/prezly/blob/9ac32bc15760636ed47eea6fe637d245fa752d32/apps/press/resources/javascripts/prezly.js#L425-L458
            var delay = type === 'image' || type === 'gallery-image' ? 500 : 0;
            window.setTimeout(function () {
                var targetEl = document.getElementById("".concat(type, "-").concat(id)) ||
                    // Fallback to data-attributes marked element
                    document.querySelector("[data-type='".concat(type, "'][data-id='").concat(id, "']"));
                if (targetEl) {
                    targetEl.click();
                }
            }, delay);
        }
    }, [trackRef]);
    return null;
}
exports.Tracking = Tracking;
//# sourceMappingURL=Tracking.js.map